import React from "react";
import LogoCarousel from "../components/LogoCarousel/LogoCarousel";
import CTA from "../components/CTA/CTA";
import Footer from "../components/Footer/Footer";
import HomeServices from "../components/HomeServices/HomeServices";
import { useLanguage } from "../LanguageContext";
import Process from "../components/Process/Process";
import Hero from "../components/Hero/Hero";
import Benefits from "../components/Benefits/Benefits";
import Services from "../components/Services/Services";


const Home = () => {
  const { t } = useLanguage();
  return (
    <>
      <Hero />
      <LogoCarousel />
      <Services />
      {/*StackingCards />*/}
      <HomeServices />
      <Process />
      <Benefits />
      <CTA />
      <Footer />
     

    </>
  );
};

export default Home;
